export default [
	{
	  title: '精选列表',
	  name: 'featured'
	}
]



// WEBPACK FOOTER //
// ./src/route/featuredRouter.js